import { Injectable } from '@angular/core';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { AppConfig } from '../../shared/config/app-config';
import { CustomArrayModel } from '../../shared/constants';
import { Subject } from 'rxjs';

@Injectable()
export class BreakDownDetailsService {
  private breakDownDetails:CustomArrayModel[];
  private title:string;
  private error:string
  private _detailModalDestroy = new Subject<any>();
  _detailModalDestroy$ = this._detailModalDestroy.asObservable();
  private _reloadDetails = new Subject<any>();
  _reloadDetails$ = this._reloadDetails.asObservable();
  private _detailsAlert = new Subject<any>();
  _detailsAlert$ = this._detailsAlert.asObservable();
  constructor(private apiClientHelper: ApiClientHelper,
                public config: AppConfig) {
  }

  setBreakDownDetails(arr:CustomArrayModel[]){
   this.breakDownDetails = arr;
  }

  getBreakDownDetails(){
    return this.breakDownDetails;
  }

  reloadDetails(){
    this._reloadDetails.next(true);
  }

  setTitle(title){
    this.title = title;
  }
  getTitle(){
    return this.title;
  }

  setDetailsAlert(arr:CustomArrayModel[],isSuccess,error?){
    this.setBreakDownDetails(arr);
    if(error){this.error = error}
    this._detailsAlert.next(isSuccess);
  }

  getError(){
    return this.error;
  }

  closeModal(){
    this._detailModalDestroy.next(true);
  }
}
